export const getQueryPayload = (queryResponse) => queryResponse?.data?.data ?? null;

export const getResponseData = (queryResponse, fallback = null) => {
  const responseData = getQueryPayload(queryResponse)?.responseData;

  return responseData ?? fallback;
};

export const getTotalRecord = (queryResponse, fallback = 0) => {
  const totalRecord = getQueryPayload(queryResponse)?.totalRecord;

  return totalRecord ?? fallback;
};
